function on_consent_library_loaded_check_linkwise() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  if (window.Shopify.customerPrivacy.shouldShowGDPRBanner()) {
    
    if (urlParams.has('lkws_13739')){
      const cookie_id = urlParams.get('lkws_13739');
      document.cookie = `linkwise_cookie_id=${cookie_id}; expires=0; path=/; domain=.finloup.com`;
    }
    
  } else if (window.Shopify.customerPrivacy.userCanBeTracked() && window.location.href.indexOf('contact_posted=true') == -1) {
    load_linkwise_site_header();
  }
  
  if (window.location.href.indexOf('contact_posted=true') != -1 &&
      window.location.pathname.indexOf('/pages/leasing-for-business') != -1) {
    load_linkwise_order_completion();
  }
  
}

function load_linkwise_site_header() {
  var linkwise_div = document.getElementById('linkwise-scripts');
  
  var s1 = document.createElement( 'script' );
  s1.setAttribute( 'src', '//go.linkwi.se/delivery/js/tl.js' );
  s1.setAttribute('async', true);
  linkwise_div.appendChild( s1 );
  
  var s2 = document.createElement( 'script' );
  s2.innerText = 'window.lw=window.lw||function(){(lw.q=lw.q||[]).push(arguments)};lw.l=+new Date;lw("setProgram", "13739");lw("setDecimal", ".");'
  linkwise_div.appendChild( s2 );
}

function load_linkwise_order_completion() {
  var linkwise_div = document.getElementById('linkwise-order-completion-scripts');
  let lead_id = sessionStorage.getItem('lead');
  
  var s1 = document.createElement( 'script' );
  s1.setAttribute( 'src', '//go.linkwi.se/delivery/js/tlwt.js' );
  s1.setAttribute('async', true);
  linkwise_div.appendChild( s1 );
  
  var s2 = document.createElement( 'script' );
  s2.innerText = 'window.lw=window.lw||function(){(lw.q=lw.q||[]).push(arguments)};lw.l=+new Date;lw("setProgram", "13739");lw("setDecimal", ".");'
  linkwise_div.appendChild( s2 );
  
  var s3 = document.createElement( 'script' );
  s3.innerText = `lw("addItem", {id: "id",price: "00.00",quantity: "1",payout: "2"});lw("thankyou", {orderid: "${lead_id}",status: "pending"});`
  linkwise_div.appendChild( s3 );
}

function reload_page_for_linkwise() {
  var url = window.location.href; 
  let lw_cookie_id = getCookie("linkwise_cookie_id");
  
  if (lw_cookie_id != "") {     
    if (url.indexOf('?') > -1) {
      if (!url.includes('lkws_13739')) {
       url += `&lkws_13739=${lw_cookie_id}`
      }
    } else {
       url += `?lkws_13739=${lw_cookie_id}`
    }
  }
  
  window.location.href = url;
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
    }
    return "";
}